"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:6.5.2'] && _();
}
catch (e) { }
